const actionPrefix = (actionType) => `MonetateExperiences/${actionType}`;

const SET_MONETATE_EXPERIENCES = actionPrefix`SET_MONETATE_EXPERIENCES`;

export default { SET_MONETATE_EXPERIENCES };
